import React, { createContext, useReducer } from 'react'
import { Program } from '../types';

export type System = {
  _id: string;
  user_id: string;
  name: string;
  description?: string;
  devices: SystemDevice[];
  programType: string;
  program?: Program;
  manualControls: ManualControls[];
  reservoir_size?: number;
  default_options: boolean;
  advanced_options: object;
  sensor_groups: SensorGroup[];
}|{} | any

type SensorGroup = {
  'Temperature': object;
}


export type ManualControls = {
  device_id: string;
  device_type: string;
  pump: number;
  dose: number;
} |
{
  device_id: string;
  device_type: string;
  outlet: number;
  status: string;
}

export type SystemDevice = {
  _id: string;
  device_id: string;
  name: string;
  device_type: string;
}

type SystemsState = {
  systems: System[] | null;
};
type SystemsAction =
  | { type: 'SET_SYSTEM'; payload: System[] }
  | { type: 'CREATE_SYSTEM'; payload: System }
  | { type: 'UPDATE_SYSTEM'; payload: System }
  | { type: 'DELETE_SYSTEM'; payload: System };

export type SystemsDispatch = (action: any) => void;

type SystemsContextType = SystemsState & {
dispatch: SystemsDispatch;
};
  
export const SystemsContext = createContext<SystemsContextType>({
  systems: null,
  dispatch: () => {},
});

export const systemsReducer = (state: SystemsState, action: any): SystemsState => {
  switch (action.type) {
    case 'SET_SYSTEM': 
      return {
        ...state,
        systems: action.payload
      }
    case 'CREATE_SYSTEM':
      return {
        ...state,
        systems: [action.payload, ...(state.systems ?? [])]
      }
    case 'UPDATE_SYSTEM':
      return {
        ...state,
        systems: (state.systems ?? []).map((s: System) =>
          (s as { _id?: string })._id === (action.payload as { _id?: string })._id
            ? action.payload
            : s
        ),
      }
    case 'DELETE_SYSTEM':
      
      return {
        ...state,
        systems: (state.systems ?? []).filter((s:any) =>  s._id !== action.payload._id)
      }
    default:
      return state
  }
}

type SystemsContextProviderProps = {
  children: React.ReactNode;
};

export const SystemsContextProvider = ({ children }: SystemsContextProviderProps) => {
  const [state, dispatch] = useReducer(systemsReducer, {
    systems: null
  });

  return (
    <SystemsContext.Provider value={{...state, dispatch}}>
      { children }
    </SystemsContext.Provider>
  )
}